import styled from 'styled-components'
import { StyledGlobalMainContainer } from '../globalStyle'

export const StyledContainer = styled(StyledGlobalMainContainer)`
	margin-top: 78px;
	position: relative;
	@media (max-width: 768px) {
		margin-top: 42px;
		padding-left: 22px;
		padding-right: 22px;
	}
	@media (max-width: 425px) {
		margin-top: 64px;
		padding-left: 22px;
		padding-right: 22px;
	}
`

export const StyledTitleContainer = styled.div``
export const StyledMainContainer = styled.div`
	margin-top: 74px;
	display: grid;
	grid-template-columns: 2fr 1fr;
	grid-column-gap: 135px;
	@media (max-width: 960px) {
		grid-column-gap: 100px;
	}
	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`
export const StyledImageContainer = styled.div``
export const StyledLeftContainer = styled.div`
	position: relative;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
`

export const StyledRightContainer = styled.div``
export const StyledIconContainer = styled.div`
	width: 132px;
	height: 132px;
	background: #ffffff;
	border: 1px solid #f7f8fa;
	box-sizing: border-box;
	box-shadow: 0 10px 34px rgba(191, 196, 202, 0.3);
	border-radius: 50%;
	display: grid;
	align-items: center;
	justify-items: center;
	position: absolute;
	${({ top }) =>
		top &&
		`
    top: ${top};
  `};
	${({ bottom }) =>
		bottom &&
		`
    bottom: ${bottom};
  `};
	${({ left }) =>
		left &&
		`
    left: ${left};
  `};
	${({ right }) =>
		right &&
		`
    right: ${right};
  `};
	@media (max-width: 960px) {
		width: 95px;
		height: 95px;
		img {
			width: 60%;
		}
	}

	@media (max-width: 768px) {
		position: unset;
		margin: 10px;
	}
`

export const StyledInnerIcon = styled.img`
	/* width: 55px;
  height: 55px; */
`

export const StyledImageWindowContainer = styled.div`
	width: 373px;
	height: 532px;
	position: relative;
	img {
		position: absolute;
		width: 100%;
		height: 100%;
		transform: scale(1.1);
	}
	@media (max-width: 768px) {
		display: none;
	}
`
